import './DataChangeVerification.less';

import React from 'react';
import { TwoFactorIdentityIcon } from '../../../../icons/TwoFactorIdentityIcon';
import { Button } from '../../../button/Button';
import { EMAIL, PHONE } from './ForcedActionCrmType';
import i18n from '../../../../common/i18n';

function ForcedActionCrm({ action, index }) {
    let text = null;
    if (action === EMAIL) {
        text = i18n('nui.two.fa.change.verification.type.email');
    } else if (action === PHONE) {
        text = i18n('nui.two.fa.change.verification.type.phone');
    }
    return (
        <div className="two-factor-ver-facrm">
            <span>{index + 1}</span>
            {text}
        </div>
    );
}
function DataChangeVerification({ forcedActionsCrm, onAction, onClose }) {
    function doAction() {
        onAction?.();
        onClose?.();
    }
    return (
        <div className="two-factor-ver-box data-change-verification">
            <TwoFactorIdentityIcon />
            <h1 className="two-factor-ver-title">{i18n('nui.two.fa.change.verification.title')}</h1>
            <h3 className="two-factor-ver-description">{i18n('nui.two.fa.change.verification.description')}</h3>
            <div className="two-factor-ver-content">
                {forcedActionsCrm.map(({ action }, index) => (
                    <ForcedActionCrm key={action} action={action} index={index} />
                ))}
            </div>
            <Button
                primary
                large
                className="two-factor-ver-submit nui-button-180"
                onClick={doAction}
                label={i18n('nui.button.continue')}
            />
        </div>
    );
}

export default DataChangeVerification;
